export enum CreditCodeType {
  Fund = 'fund',
  Label = 'label',
}
